import React from 'react';
import {Redirect, Link} from 'react-router-dom'
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {withStyles} from '@material-ui/core/styles';
import ApiFetcher from '../../ApiFetcher';
import Utility from '../../Utility';
import encoding from 'encoding-japanese';

const styles = theme => ({
    root: {
        textAlign: 'center'
    },
    textField: {
        margin: 'auto',
        width: '80%',
        float: 'left',
    },
    button: {
        margin: 'auto',
        width: '30%',
        marginTop: theme.spacing.unit * 8,
    },
    buttonSelect: {
        margin: 'auto',
        width: '100%',
    },
    buttonUpload: {
        margin: 'auto',
        marginTop: theme.spacing.unit * 2,
        width: '100%',
        float: 'right',
    },
    circularProgress: {
        margin: theme.spacing.unit,
    },
    form: {
        width: '90%',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 2,
    },
    errorMessage: {
        color: 'red'
    },
});

const numberOfItems = 234;
const keyRecord = "sceneName,sceneDetailNumber,sceneDetailName,instrumentProcess,instrumentApparatus,instrumentMachineNumber,instrumentShellSideFluid,instrumentTubeSideFluid,instrumentNumberOfLines,instrumentType,instrumentMaterial,instrumentLength,instrumentOuterDiameter,instrumentThickness,instrumentInnerDiameter,instrumentWeight,remarks1IronSulfide,remarks1OnePressure,remarks1PureWaterDesignation,remarks1NeutralizationDesignation,planOfCrInternalMpa,planOfCrExternalMpa,planOfCrSuperHigh,planOfProcessCarryInDate,planOfProcessAirBlow,planOfProcessEt,planOfProcessFtect,planOfProcessIris,planOfProcessCarryOutDate,remarks2Scrap,remarks2Ritube,note,resultOfCrisGan1ConstructionMethod,resultOfCrisGan1Specification,resultOfCrisGan1Nozzle,resultOfCrisGan1Pressure,resultOfCrisGan1IsStart,resultOfCrisGan1StartDatetime,resultOfCrisGan1IsStop,resultOfCrisGan1StopDatetime,resultOfCrisGan1StopCumulativeMinute,resultOfCrisGan1IsComplete,resultOfCrisGan1CompleteDatetime,resultOfCrisGan1WorkCumulativeMinute,resultOfCrisGan1AdditionalReason,resultOfCrisGan2ConstructionMethod,resultOfCrisGan2Specification,resultOfCrisGan2Nozzle,resultOfCrisGan2Pressure,resultOfCrisGan2IsStart,resultOfCrisGan2StartDatetime,resultOfCrisGan2IsStop,resultOfCrisGan2StopDatetime,resultOfCrisGan2StopCumulativeMinute,resultOfCrisGan2IsComplete,resultOfCrisGan2CompleteDatetime,resultOfCrisGan2WorkCumulativeMinute,resultOfCrisGan2AdditionalReason,resultOfCrisFlexi1ConstructionMethod,resultOfCrisFlexi1Specification,resultOfCrisFlexi1Nozzle,resultOfCrisFlexi1Pressure,resultOfCrisFlexi1IsStart,resultOfCrisFlexi1StartDatetime,resultOfCrisFlexi1IsStop,resultOfCrisFlexi1StopDatetime,resultOfCrisFlexi1StopCumulativeMinute,resultOfCrisFlexi1IsComplete,resultOfCrisFlexi1CompleteDatetime,resultOfCrisFlexi1WorkCumulativeMinute,resultOfCrisFlexi1AdditionalReason,resultOfCrisFlexi2ConstructionMethod,resultOfCrisFlexi2Specification,resultOfCrisFlexi2Nozzle,resultOfCrisFlexi2Pressure,resultOfCrisFlexi2IsStart,resultOfCrisFlexi2StartDatetime,resultOfCrisFlexi2IsStop,resultOfCrisFlexi2StopDatetime,resultOfCrisFlexi2StopCumulativeMinute,resultOfCrisFlexi2IsComplete,resultOfCrisFlexi2CompleteDatetime,resultOfCrisFlexi2WorkCumulativeMinute,resultOfCrisFlexi2AdditionalReason,resultOfCrisEquipment1ConstructionMethod,resultOfCrisEquipment1Specification,resultOfCrisEquipment1Nozzle,resultOfCrisEquipment1Pressure,resultOfCrisEquipment1IsStart,resultOfCrisEquipment1StartDatetime,resultOfCrisEquipment1IsStop,resultOfCrisEquipment1StopDatetime,resultOfCrisEquipment1StopCumulativeMinute,resultOfCrisEquipment1IsComplete,resultOfCrisEquipment1CompleteDatetime,resultOfCrisEquipment1WorkCumulativeMinute,resultOfCrisEquipment1AdditionalReason,resultOfCrisEquipment2ConstructionMethod,resultOfCrisEquipment2Specification,resultOfCrisEquipment2Nozzle,resultOfCrisEquipment2Pressure,resultOfCrisEquipment2IsStart,resultOfCrisEquipment2StartDatetime,resultOfCrisEquipment2IsStop,resultOfCrisEquipment2StopDatetime,resultOfCrisEquipment2StopCumulativeMinute,resultOfCrisEquipment2IsComplete,resultOfCrisEquipment2CompleteDatetime,resultOfCrisEquipment2WorkCumulativeMinute,resultOfCrisEquipment2AdditionalReason,resultOfCrisLance1ConstructionMethod,resultOfCrisLance1Specification,resultOfCrisLance1Nozzle,resultOfCrisLance1Pressure,resultOfCrisLance1IsStart,resultOfCrisLance1StartDatetime,resultOfCrisLance1IsStop,resultOfCrisLance1StopDatetime,resultOfCrisLance1StopCumulativeMinute,resultOfCrisLance1IsComplete,resultOfCrisLance1CompleteDatetime,resultOfCrisLance1WorkCumulativeMinute,resultOfCrisLance1AdditionalReason,resultOfCrisLance2ConstructionMethod,resultOfCrisLance2Specification,resultOfCrisLance2Nozzle,resultOfCrisLance2Pressure,resultOfCrisLance2IsStart,resultOfCrisLance2StartDatetime,resultOfCrisLance2IsStop,resultOfCrisLance2StopDatetime,resultOfCrisLance2StopCumulativeMinute,resultOfCrisLance2IsComplete,resultOfCrisLance2CompleteDatetime,resultOfCrisLance2WorkCumulativeMinute,resultOfCrisLance2AdditionalReason,resultOfCrosGan1ConstructionMethod,resultOfCrosGan1Specification,resultOfCrosGan1Nozzle,resultOfCrosGan1Pressure,resultOfCrosGan1IsStart,resultOfCrosGan1StartDatetime,resultOfCrosGan1IsStop,resultOfCrosGan1StopDatetime,resultOfCrosGan1StopCumulativeMinute,resultOfCrosGan1IsComplete,resultOfCrosGan1CompleteDatetime,resultOfCrosGan1WorkCumulativeMinute,resultOfCrosGan1AdditionalReason,resultOfCrosGan2ConstructionMethod,resultOfCrosGan2Specification,resultOfCrosGan2Nozzle,resultOfCrosGan2Pressure,resultOfCrosGan2IsStart,resultOfCrosGan2StartDatetime,resultOfCrosGan2IsStop,resultOfCrosGan2StopDatetime,resultOfCrosGan2StopCumulativeMinute,resultOfCrosGan2IsComplete,resultOfCrosGan2CompleteDatetime,resultOfCrosGan2WorkCumulativeMinute,resultOfCrosGan2AdditionalReason,resultOfCrosEquipment1ConstructionMethod,resultOfCrosEquipment1Specification,resultOfCrosEquipment1Nozzle,resultOfCrosEquipment1Pressure,resultOfCrosEquipment1IsStart,resultOfCrosEquipment1StartDatetime,resultOfCrosEquipment1IsStop,resultOfCrosEquipment1StopDatetime,resultOfCrosEquipment1StopCumulativeMinute,resultOfCrosEquipment1IsComplete,resultOfCrosEquipment1CompleteDatetime,resultOfCrosEquipment1WorkCumulativeMinute,resultOfCrosEquipment1AdditionalReason,resultOfCrosEquipment2ConstructionMethod,resultOfCrosEquipment2Specification,resultOfCrosEquipment2Nozzle,resultOfCrosEquipment2Pressure,resultOfCrosEquipment2IsStart,resultOfCrosEquipment2StartDatetime,resultOfCrosEquipment2IsStop,resultOfCrosEquipment2StopDatetime,resultOfCrosEquipment2StopCumulativeMinute,resultOfCrosEquipment2IsComplete,resultOfCrosEquipment2CompleteDatetime,resultOfCrosEquipment2WorkCumulativeMinute,resultOfCrosEquipment2AdditionalReason,resultOfCrshNum1ConstructionMethod,resultOfCrshNum1Specification,resultOfCrshNum1Nozzle,resultOfCrshNum1Pressure,resultOfCrshNum1IsStart,resultOfCrshNum1StartDatetime,resultOfCrshNum1IsStop,resultOfCrshNum1StopDatetime,resultOfCrshNum1StopCumulativeMinute,resultOfCrshNum1IsComplete,resultOfCrshNum1CompleteDatetime,resultOfCrshNum1WorkCumulativeMinute,resultOfCrshNum1AdditionalReason,resultOfCrshNum2ConstructionMethod,resultOfCrshNum2Specification,resultOfCrshNum2Nozzle,resultOfCrshNum2Pressure,resultOfCrshNum2IsStart,resultOfCrshNum2StartDatetime,resultOfCrshNum2IsStop,resultOfCrshNum2StopDatetime,resultOfCrshNum2StopCumulativeMinute,resultOfCrshNum2IsComplete,resultOfCrshNum2CompleteDatetime,resultOfCrshNum2WorkCumulativeMinute,resultOfCrshNum2AdditionalReason,resultOfProcessIsCompleteCarryIn,resultOfProcessCarryInDatetime,resultOfProcessIsCompletePretest,resultOfProcessPretestDatetime,resultOfProcessIsCompleteAirBlow,resultOfProcessAirBlowDatetime,resultOfProcessIsCompleteEt,resultOfProcessEtDatetime,resultOfProcessIsCompleteFtect,resultOfProcessFtectDatetime,resultOfProcessIsCompleteIris,resultOfProcessIrisDatetime,resultOfProcessIsCompleteCarryOut,resultOfProcessCarryOutDatetime,systemInfoLayoutAzimuthAngle,systemInfoPositionX,systemInfoPositionY,systemInfoRotation,systemInfoAdditionalFlag,systemInfoUpdateDate";

export class UploadConstructionPlan extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            file: {},
            isWaitUpload: false,
            infoDialogOpen: false,
            alertDialogOpen: false,
            error: [],
            csvId: null,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.completeReadFileAction = this.completeReadFileAction.bind(this);
        this.validateCsv = this.validateCsv.bind(this);
        this.csv2json = this.csv2json.bind(this);
        this.handleResponse = this.handleResponse.bind(this);
        this.isDisabledUploadButton = this.isDisabledUploadButton.bind(this);
        this.selectFile = this.selectFile.bind(this);
        this.onDialogClose = this.onDialogClose.bind(this);
        
        if(this.props.onScreen !== undefined){
            this.props.onScreen('工事計画CSVアップロード画面', true);
        }
    }

    handleSubmit(){
        // CSVファイル以外は処理を止める
        if(!this.state.file.name.match('.csv$')){
            alert('選択したファイルはCSV形式ではありません。');
            this.setState({file: {}});
        }else{
            this.setState({isWaitUpload: true}, () => {
                let reader = new FileReader();
                reader.readAsBinaryString(this.state.file);
                reader.addEventListener('abort', () => {
                    alert('選択したファイルの読み込みが中断されました。');
                    this.setState({file: {}, isWaitUpload: false});
                });
                reader.addEventListener('error', () => {
                    alert('選択したファイルの読み込みに失敗しました。');
                    this.setState({file: {}, isWaitUpload: false});
                });
                reader.addEventListener('load', this.completeReadFileAction);
            });
        }
    }

    completeReadFileAction(event){
        let errorMsg = [];
        // ファイル読み取り結果取得
        let inputArray = event.target.result;
        // 文字コードを判定
        const detected = encoding.detect(inputArray);
        let uniArray = encoding.convert(inputArray, {
                to: 'unicode',
                from: detected
        });
        // 1行ごとに分割する
        let lines = uniArray.split('\n');
        // 形式チェック
        errorMsg = this.validateCsv(lines);
        if(errorMsg.length === 0){
            // JSON形式に変換
            let jsonArray = this.csv2json(lines);
            // API呼び出し
            ApiFetcher.postSceneUpload(this.props.cookies.get('token'), jsonArray, this.handleResponse);
            event.preventDefault();
        }else{
            this.setState({error: errorMsg, isWaitUpload: false, alertDialogOpen: true});
        }
    }

    validateCsv(lines){
        let recCnt = 0;
        // CSVデータの配列の各行をループ処理する
        for (let i = 0; i < lines.length; i++) {
            // 空行は無視する
            if(lines[i].split(',').length === 1){
                continue;
            }
            // カンマで区切られた各データに分割する
            let data = lines[i].split(',');
            // 項目数チェック
            if(data.length !== numberOfItems){
                return [
                    'CSVの項目数が想定している項目数ではありません。\n' + 
                    '想定項目数：' + numberOfItems + ' 取込項目数：' + data.length
                ];
            }
            recCnt ++;
        }
        if(recCnt === 0){
            return ['CSVファイル内にデータがありません。'];
        }else{
            return [];
        }
    }

    csv2json(lines){
        let jsonArray = [];
        let keyItems = keyRecord.split(',');
        // CSVデータの配列の各行をループ処理する
        for (let lineIndex = 0; lineIndex < lines.length; lineIndex++) {
            // 空行は無視する
            if(lines[lineIndex].split(',').length === 1){
                continue;
            }
            let addLine = {};
            // カンマで区切られた各データに分割する
            let valueItems = lines[lineIndex].split(',');
            // 各データをループ処理する
            for (let itemIndex = 0; itemIndex < keyItems.length; itemIndex++) {
                // 要素名：keyItems[itemIndex]
                // データ：valueItems[itemIndex]
                addLine[keyItems[itemIndex]] = valueItems[itemIndex];
            }
            jsonArray.push(addLine);
        }
        return jsonArray;
    }

    handleResponse(responseJson){
        if(Utility.isNullOrUndefined(responseJson.result)){
            let errorMessage = [];
            for (let i = 0; i < responseJson.message.length; i++) {
                errorMessage.push(responseJson.message[i].errorMessage + '\n');
            }
            this.setState({error: errorMessage, isWaitUpload: false, alertDialogOpen: true});
        }else{
            // csvId を state に保存
            const csvId = responseJson.result.csvId;
            this.setState({isWaitUpload: false, infoDialogOpen: true, csvId: csvId});
        }
    }

    isDisabledUploadButton(){
        if(!Utility.isNullOrUndefined(this.state.file.name)){
            return false;
        }
        return true;
    }

    selectFile = (e) => {
        if(!Utility.isNullOrUndefined(e.target.files[0])){
            this.setState({file: e.target.files[0]});
        }
    }

    onDialogClose(){
        // ダイアログを閉じたらエラーメッセージ、選択ファイル、ダイアログ表示フラグ、csvIDをリセット.
        this.setState({error: [], file: {}, infoDialogOpen: false, alertDialogOpen: false, csvId: null,});
    }

    render(){
        // KECアカウントでない場合はアクセス不可のためトップ画面へリダイレクト.
        if(!Utility.isKecRole(this.props.cookies.get('role'))){
            return <Redirect to={{pathname: '/'}}/>;
        }

        return (
            <div className={this.props.classes.root}>
                <div className={this.props.classes.form}>
                    <div>
                        <Grid container spacing={8}>
                            <Grid item xs={2}>
                                <input
                                    hidden={true}
                                    accept="text/csv"
                                    className={this.props.classes.input}
                                    id="contained-button-file"
                                    type="file"                            
                                    onChange={this.selectFile}
                                    onClick={(event)=>{
                                        event.target.value = ''
                                    }}
                                />
                                <label htmlFor="contained-button-file">
                                    <Button variant="contained" color="primary" component="span" className={this.props.classes.buttonSelect}>
                                        ファイル選択
                                    </Button>
                                </label>
                            </Grid>
                            <Grid item xs={10}>
                                <TextField className={this.props.classes.textField} id="file-name" value={ Utility.isNullOrUndefined(this.state.file.name) ? '' : this.state.file.name } InputProps={{readOnly: true,}}/>
                            </Grid>
                        </Grid>
                    </div>
                    <div>
                        <Grid container>
                            <Grid item xs={8}>
                            </Grid>
                            <Grid item xs={2}>
                                <Button disabled={this.isDisabledUploadButton()} variant="contained" color="primary" className={this.props.classes.buttonUpload} onClick={this.handleSubmit}>
                                    アップロード
                                </Button>
                            </Grid>
                        </Grid>
                    </div>
                    <div className={this.props.classes.button}>
                        <Button component={(props) => <Link to={this.props.backPath} {...props}/>} variant="contained" color="primary" fullWidth>トップ画面へ戻る</Button>
                    </div>
                    <Dialog id="wait-dialog" open={this.state.isWaitUpload}>
                        <DialogContent>
                            <CircularProgress className={this.props.classes.circularProgress}/>
                        </DialogContent>
                    </Dialog>
                    <Dialog id="info-dialog" open={this.state.infoDialogOpen} onClose={this.onDialogClose}>
                        <DialogTitle>{'熱交情報登録'}</DialogTitle>
                        <DialogContent>
                            <DialogContentText style={{whiteSpace: 'pre'}}>
                                熱交仕様CSV登録が正常に完了しました。
                                {'\n'}
                                csvID: {this.state.csvId}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.onDialogClose} color="primary" autoFocus>
                                OK
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog id="alert-dialog" open={this.state.alertDialogOpen} onClose={this.onDialogClose}>
                        <DialogContent>
                            <DialogContentText style={{whiteSpace: 'pre'}}>
                                {this.state.error}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.onDialogClose} color="primary" autoFocus>
                                OK
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(UploadConstructionPlan);
